/* VERGENT - extras:
   1) Botón flotante de WhatsApp (apagado: cambiar SHOW_WHATSAPP a true para activarlo)
   2) Bloque de envíos y pagos debajo del botón de compra
   3) Selector de color y talla en las tarjetas + "Agregar al carrito" directo */
(function () {
  var SHOW_WHATSAPP = false;
  var PHONE = '51966955881';

  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2C6.48 2 2 6.03 2 11c0 2.4 1.05 4.58 2.77 6.19L4 22l4.37-2.3c1.13.33 2.35.5 3.63.5 5.52 0 10-4.03 10-9S17.52 2 12 2z"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 6h13v10H1z"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>';
  var ICON_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5 12 12l9-4.5"/><path d="M12 12v9"/></svg>';
  var ICON_CARD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/><path d="M6 15h4"/></svg>';

  var TRUST_HTML =
    '<div class="vgt-trust">' +
      '<div class="vgt-trust__item">' + ICON_TRUCK + '<span><strong>Lima:</strong> motorizado a domicilio (Lima Centro y alrededores), de 3 a 4 días.</span></div>' +
      '<div class="vgt-trust__item">' + ICON_BOX + '<span><strong>Provincias:</strong> envío por Shalom, de 4 a 6 días.</span></div>' +
      '<div class="vgt-trust__item">' + ICON_CARD + '<span><strong>Pagos:</strong> Yape, Plin y tarjetas de crédito o débito.</span></div>' +
    '</div>';

  /* ---------- 1) WhatsApp ---------- */
  function productName() {
    var el = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    return el ? el.textContent.trim() : '';
  }

  function waUrl() {
    var name = productName();
    var text = name
      ? 'Hola VERGENT, me interesa el ' + name + ': ' + window.location.href.split('?')[0]
      : 'Hola VERGENT, tengo una consulta';
    return 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(text);
  }

  function addWhatsAppButton() {
    if (!SHOW_WHATSAPP || document.querySelector('.vgt-wa')) return;
    var a = document.createElement('a');
    a.className = 'vgt-wa';
    a.href = waUrl();
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Escríbenos por WhatsApp');
    a.innerHTML = ICON_CHAT + '<span class="vgt-wa__label">Escríbenos</span>';
    a.addEventListener('click', function () { a.href = waUrl(); });
    document.body.appendChild(a);
  }

  /* ---------- 2) Envíos y pagos ---------- */
  function addTrustBlocks() {
    document.querySelectorAll('product-form.product-form').forEach(function (form) {
      if (form.dataset.vgtTrust) return;
      form.dataset.vgtTrust = '1';
      form.insertAdjacentHTML('afterend', TRUST_HTML);
    });
  }

  /* ---------- 3) Selector de color y talla ---------- */
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initPicker(picker) {
    if (picker.dataset.vgtReady) return;
    picker.dataset.vgtReady = '1';

    var dataEl = picker.querySelector('.vgt-picker__data');
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var ci = parseInt(picker.dataset.colorIndex, 10);
    var si = parseInt(picker.dataset.sizeIndex, 10);
    var swatches = Array.prototype.slice.call(picker.querySelectorAll('.vgt-swatch'));
    var sizes = Array.prototype.slice.call(picker.querySelectorAll('.vgt-size'));
    var addBtn = picker.querySelector('.vgt-add');
    var msg = picker.querySelector('.vgt-picker__msg');
    var wrapper = picker.closest('.card-wrapper');
    if (wrapper) wrapper.classList.add('vgt-has-picker');

    var state = { color: null, size: null, busy: false };
    if (ci > -1 && swatches.length === 1) state.color = swatches[0].dataset.value;
    if (si > -1 && sizes.length === 1) state.size = sizes[0].dataset.value;

    function matches(v, color, size) {
      return (ci < 0 || color === null || v.options[ci] === color) &&
             (si < 0 || size === null || v.options[si] === size);
    }

    function anyAvailable(color, size) {
      return variants.some(function (v) { return v.available && matches(v, color, size); });
    }

    function selectedVariant() {
      if ((ci > -1 && state.color === null) || (si > -1 && state.size === null)) return null;
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], state.color, state.size)) return variants[i];
      }
      return null;
    }

    function render() {
      if (state.size !== null && !anyAvailable(state.color, state.size)) state.size = null;

      swatches.forEach(function (b) {
        var on = b.dataset.value === state.color;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-unavailable', !anyAvailable(b.dataset.value, null));
      });

      sizes.forEach(function (b) {
        var on = b.dataset.value === state.size;
        var available = anyAvailable(state.color, b.dataset.value);
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = !available;
        b.title = available ? '' : 'Agotado';
      });

      if (state.busy) return;
      var needColor = ci > -1 && state.color === null;
      var needSize = si > -1 && state.size === null;
      var v = selectedVariant();
      var label = 'Agregar al carrito';
      if (needColor && needSize) label = 'Elige color y talla';
      else if (needColor) label = 'Elige un color';
      else if (needSize) label = 'Elige una talla';
      else if (!v || !v.available) label = 'Agotado';
      addBtn.textContent = label;
      addBtn.disabled = !(v && v.available);
    }

    swatches.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        state.color = b.dataset.value;
        msg.textContent = '';
        render();
      });
    });

    sizes.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (b.disabled) return;
        state.size = b.dataset.value;
        msg.textContent = '';
        render();
      });
    });

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var v = selectedVariant();
      if (!v || !v.available || state.busy) return;

      state.busy = true;
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      addBtn.textContent = 'Agregando...';
      msg.textContent = '';

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = new FormData();
      body.append('id', v.id);
      body.append('quantity', 1);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(addBtn);
      }

      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            msg.textContent = res.description || res.message || 'No se pudo agregar al carrito.';
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(res);
            var bubble = document.querySelector('#cart-icon-bubble');
            if (bubble && cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          } else {
            window.location.href = cartRoot() + 'cart';
          }
        })
        .catch(function () {
          msg.textContent = 'No se pudo agregar al carrito. Inténtalo de nuevo.';
        })
        .then(function () {
          state.busy = false;
          addBtn.classList.remove('is-loading');
          render();
        });
    });

    render();
  }

  function initPickers() {
    document.querySelectorAll('.vgt-picker').forEach(initPicker);
  }

  /* ---------- Arranque ---------- */
  function init() {
    addWhatsAppButton();
    addTrustBlocks();
    initPickers();
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      addTrustBlocks();
      initPickers();
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();